export default __webpack_public_path__ + "static/media/InsideMuscles_11.139b1ce2.png";